/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const tradingChallengeResultStatusEnum = {
  PENDING: 'PENDING',
  FUNDED: 'FUNDED',
  ACTIVE: 'ACTIVE',
  BUSTED: 'BUSTED',
  COMPLETED: 'COMPLETED',
  PRIZE_CLAIMED: 'PRIZE_CLAIMED',
  TERMINATED: 'TERMINATED',
} as const

export type TradingChallengeResultStatusEnum =
  (typeof tradingChallengeResultStatusEnum)[keyof typeof tradingChallengeResultStatusEnum]

export const tradingChallengeResultCrownEnum = {
  NONE: 'NONE',
  PNL_GOLD: 'PNL_GOLD',
  PNL_SILVER: 'PNL_SILVER',
  PNL_BRONZE: 'PNL_BRONZE',
  VOLUME_GOLD: 'VOLUME_GOLD',
  VOLUME_SILVER: 'VOLUME_SILVER',
  VOLUME_BRONZE: 'VOLUME_BRONZE',
  IRON_GOLD: 'IRON_GOLD',
  IRON_SILVER: 'IRON_SILVER',
  IRON_BRONZE: 'IRON_BRONZE',
  CASH_CROWN: 'CASH_CROWN',
} as const

export type TradingChallengeResultCrownEnum =
  (typeof tradingChallengeResultCrownEnum)[keyof typeof tradingChallengeResultCrownEnum]

export const tradingChallengeResultDeactivationStatusEnum = {
  ACTIVE: 'ACTIVE',
  DEACTIVATED: 'DEACTIVATED',
} as const

export type TradingChallengeResultDeactivationStatusEnum =
  (typeof tradingChallengeResultDeactivationStatusEnum)[keyof typeof tradingChallengeResultDeactivationStatusEnum]

export type TradingChallengeResult = {
  /**
   * @description
   * Format: `uuid`
   * @type string | undefined
   */
  trading_challenge_id?: string
  /**
   * @description
   * Format: `uuid`
   * @type string | undefined
   */
  user_id?: string
  user_name?: string
  /**
   * @description
   * Format: `decimal`
   * @type string | undefined
   */
  cum_volume?: string
  /**
   * @description
   * Format: `decimal`
   * @type string | undefined
   */
  cum_pnl?: string
  /**
   * @description
   * Format: `decimal`
   * @type string | undefined
   */
  pnl_pct?: string
  calendar_days_since_start?: number
  active_days?: number
  compliant_days?: number
  crown_eligible?: boolean
  claim_eligible?: boolean
  status?: TradingChallengeResultStatusEnum
  crown?: TradingChallengeResultCrownEnum
  /**
   * @description
   * Format: `date-time`
   * @type string | undefined
   */
  created_at?: string
  deactivation_status?: TradingChallengeResultDeactivationStatusEnum
  /**
   * @description
   * Format: `decimal`
   * @type string | undefined
   */
  current_day_daily_volume?: string
  /**
   * @description
   * Format: `decimal`
   * @type string | undefined
   */
  current_day_daily_pnl?: string
  /**
   * @description
   * Format: `date`
   * @type string | undefined
   */
  current_day_trading_date?: string
  cum_trades?: number
  /**
   * @description Returned only to admins, or to competition managers for participants of their assigned competitions; omitted otherwise.
   * @type string | undefined
   */
  email?: string
  /**
   * @description Returned only to admins, or to competition managers for participants of their assigned competitions; omitted otherwise.
   * @type string | undefined
   */
  first_name?: string
  /**
   * @description Returned only to admins, or to competition managers for participants of their assigned competitions; omitted otherwise.
   * @type string | undefined
   */
  last_name?: string
  /**
   * @description Returned only to admins, or to competition managers for participants of their assigned competitions; omitted otherwise.
   * @type string | undefined
   */
  country_of_domicile?: string
}
